import { IconButton, TextField } from '@material-ui/core';
import { CloseRounded } from '@material-ui/icons';
import React from 'react';
import styled from 'styled-components/macro';

export const renderClearButton = (handleClear) => {
  return (
    <SIconButton size="small" onClick={() => handleClear()}>
      <CloseRounded fontSize="small" />
    </SIconButton>
  );
};

const ClearableSingleTextField = ({
  name,
  label,
  value,
  handleValueChange,
  disabled,
}) => {
  const handleClear = () => {
    handleValueChange(name, '');
  };
  return (
    <SClearableSingleTextField
      className={!!value ? 'show-close' : ''}
    >
      <STextField
        InputLabelProps={{ shrink: true }}
        variant="outlined"
        color="primary"
        label={label}
        value={value}
        onChange={(e) => handleValueChange(name, e.target.value)}
        disabled={disabled}
      />
      {/* only show the button when has to value to clear */}
      {renderClearButton(handleClear)}
    </SClearableSingleTextField>
  );
};

export default ClearableSingleTextField;
export const SIconButton = styled(IconButton)`
  &.MuiIconButton-root {
    position: absolute;
    right: 0;
    top: 10px;
  }
`;

const SClearableSingleTextField = styled.div.attrs((props) => ({
  className: props.className,
}))`
  position: relative;
  &.show-close ${SIconButton} {
    visibility: hidden;
    opacity: 0;
    transition: visibility 0.15s, opacity 0.15s;
  }
  &.show-close:hover ${SIconButton} {
    visibility: visible;
    opacity: 1;
  }
  &:not(.show-close) ${SIconButton} {
    visibility: hidden;
    opacity: 0;
  }
`;
const STextField: any = styled(TextField)`
  &.MuiFormControl-root {
    display: grid;
  }
  & .MuiOutlinedInput-input {
    padding: 15.5px 14px;
    font-size: ${(props) => props.theme.typography.fontSize.small};
  }
  & .MuiOutlinedInput-root {
    &:hover fieldset {
      border-color: ${(props) => props.theme.palette.primary.main};
    }
  }
  & .MuiInputLabel-outlined.MuiInputLabel-shrink {
    transform: translate(2px, 2px) scale(0.75);
    margin-left: 5px;
  }
  & legend {
    width: 0;
  }
`;
